<template>
  <div
    id="close-ticket-modal"
    ref="modal"
    class="modal fade sp-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="close-ticket-title"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <form class="modal-content" @submit.prevent="submit">
        <div class="modal-header">
          <div>
            <h5 id="close-ticket-title" class="modal-title">
              Close {{ tickets.length }} {{ tickets.length === 1 ? "ticket" : "tickets" }}
            </h5>
            <p class="sp-modal-subtitle">{{ subtitle }}</p>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <ul class="sp-close-list">
            <li v-for="ticket in tickets" :key="ticket.id">
              <strong>#{{ ticket.id }}</strong>
              <span>{{ ticket.type }}</span>
              <span v-if="!isMine(ticket) && ticket.creator_name" class="sp-sub">
                · {{ ticket.creator_name }}
              </span>
            </li>
          </ul>

          <div class="form-group mb-0">
            <label for="close-ticket-comment">{{ commentLabel }}</label>
            <textarea
              id="close-ticket-comment"
              v-model="comment"
              class="form-control"
              rows="3"
              maxlength="2000"
              :placeholder="commentPlaceholder"
            ></textarea>
            <small class="form-text text-muted">{{ commentHelp }}</small>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-success" :disabled="submitting || !tickets.length">
            <span v-if="submitting" class="spinner-border spinner-border-sm mr-1"></span>
            {{ submitting ? "Closing…" : tickets.length === 1 ? "Close ticket" : "Close tickets" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { errorMessage } from "../../supportOptions";

export default {
  name: "CloseTicketModal",
  props: {
    currentUserId: { type: [Number, String], default: null },
  },
  data() {
    return {
      tickets: [],
      comment: "",
      submitting: false,
    };
  },
  computed: {
    mineCount() {
      return this.tickets.filter((ticket) => this.isMine(ticket)).length;
    },
    allMine() {
      return this.tickets.length > 0 && this.mineCount === this.tickets.length;
    },
    noneMine() {
      return this.mineCount === 0;
    },
    subtitle() {
      if (this.allMine) return "Close them once the problem is fixed. You can reopen a ticket later.";
      return "The requesters are notified. You can reopen a ticket later if needed.";
    },
    commentLabel() {
      if (this.allMine) return "Feedback (optional)";
      if (this.noneMine) return "Closing note (optional)";
      return "Comment (optional)";
    },
    commentPlaceholder() {
      return this.allMine
        ? "How did it go? Anything the support team could do better?"
        : "What was done, if not already recorded";
    },
    commentHelp() {
      if (this.allMine) return "Shared with the support team.";
      if (this.noneMine) return "Added to “Actions taken” on each ticket.";
      return "Saved as your feedback on your own tickets and added to “Actions taken” on the others.";
    },
  },
  beforeDestroy() {
    $(this.$refs.modal).modal("hide");
  },
  methods: {
    isMine(ticket) {
      return Number(ticket.creator_id) === Number(this.currentUserId);
    },
    open(tickets) {
      this.tickets = (tickets || []).filter((ticket) => ticket.status !== "Closed");
      this.comment = "";
      if (!this.tickets.length) {
        toastr.info("The selected tickets are already closed.", "Nothing to close");
        return;
      }
      $(this.$refs.modal).modal("show");
    },
    submit() {
      if (this.submitting || !this.tickets.length) return;

      this.submitting = true;
      axios
        .post("api/support/tickets/close", {
          ids: this.tickets.map((ticket) => ticket.id),
          feedback: this.comment.trim(),
        })
        .then((res) => {
          const skipped = res.data.skipped || 0;
          if (skipped) toastr.warning(res.data.message, "Some tickets were skipped");
          else toastr.success(res.data.message, "Tickets closed");
          this.$emit("closed");
          $(this.$refs.modal).modal("hide");
        })
        .catch((err) => {
          toastr.error(errorMessage(err), "Not closed");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
